import { Action } from '../types/types';
import { SlidingMenuOption } from '../../components/general-components/sliding-menu';
import { MediaFilters, UserInterfaceState } from '../types/user-interface';
import { StylePackData } from '../../components/types/stylepacks';
import {
	SolutionCenterContent,
	SolutionCenterContentStateAction,
	SolutionCenterDrawerStateAction,
	SolutionCenterDrawerStates,
	SolutionCenterViews,
} from '../../types/solution-center';

export const SET_TEMPORARY_EDITED_USER = 'SET_TEMPORARY_EDITED_USER';
export function setTemporaryEditedUser(userId: number | null): Action {
	return {
		type: SET_TEMPORARY_EDITED_USER,
		payload: userId,
	};
}

export const SET_TEMPORARY_EDITED_USER_WEBRTC_ID = 'SET_TEMPORARY_EDITED_USER_WEBRTC_ID';
export function setTemporaryEditedUserWebRTCId(webRtcId: string | null = null): Action {
	return {
		type: SET_TEMPORARY_EDITED_USER_WEBRTC_ID,
		payload: webRtcId,
	};
}

export const SET_SHOWBOARD_EXPANDED = 'SET_SHOWBOARD_EXPANDED';
export function setShowboardExpanded(isShowboardExpanded: boolean): Action {
	return {
		type: SET_SHOWBOARD_EXPANDED,
		payload: isShowboardExpanded,
	};
}

export const SET_LIST_SORT_TYPE = 'SET_LIST_SORT_TYPE';
export function setListSortType(listSortType: string): Action {
	return {
		type: SET_LIST_SORT_TYPE,
		payload: listSortType,
	};
}

export const SET_LIST_SHOW_PAST = 'SET_LIST_SHOW_PAST';
export function setListShowPast(listShowPast: boolean): Action {
	return {
		type: SET_LIST_SHOW_PAST,
		payload: listShowPast,
	};
}

export const SET_LIST_SHOW_ALL = 'SET_LIST_SHOW_ALL';
export function setListShowAll(listShowAll: boolean): Action {
	return {
		type: SET_LIST_SHOW_ALL,
		payload: listShowAll,
	};
}

export const SET_SHOW_CALENDAR = 'SET_SHOW_CALENDAR';
export function setShowCalendar(showCalendar: boolean): Action {
	return {
		type: SET_SHOW_CALENDAR,
		payload: showCalendar,
	};
}

export const SET_SELECTED_CALENDAR_VIEW = 'SET_SELECTED_CALENDAR_VIEW';
export function setSelectedCalendarView(selectedCalendarView: string): Action {
	return {
		type: SET_SELECTED_CALENDAR_VIEW,
		payload: selectedCalendarView,
	};
}

export const SET_SELECTED_CALENDAR_OPTION = 'SET_SELECTED_CALENDAR_OPTION';
export function setSelectedCalendarOption(
	selectedCalendarOption: SlidingMenuOption | null,
): Action {
	return {
		type: SET_SELECTED_CALENDAR_OPTION,
		payload: selectedCalendarOption,
	};
}

export const SET_MEDIA_FILTERS = 'SET_MEDIA_FILTERS';
export function setMediaFilters(mediaFilters: MediaFilters) {
	return {
		type: SET_MEDIA_FILTERS,
		payload: mediaFilters,
	};
}

export const SET_OPEN_CONTEXT_MENU_ID = 'SET_OPEN_CONTEXT_MENU_ID';
export function setOpenContextMenuId(openContextMenuId: UserInterfaceState['openContextMenuId']) {
	return {
		type: SET_OPEN_CONTEXT_MENU_ID,
		payload: openContextMenuId,
	};
}

interface dragUpdatePayload {
	globalIsDragging: boolean | null,
	idOfDragging: string | number | null,
	typeOfDragging: string | null
}
export const SET_DRAGGING_PROPS = 'SET_DRAGGING_PROPS';
export function setDraggingProps(dragUpdate: dragUpdatePayload | null): Action {
	return {
		type: SET_DRAGGING_PROPS,
		payload: dragUpdate ?? { globalIsDragging: null, idOfDragging: null, typeOfDragging: null },
	};
}

export const SET_STYLE_PACK_TYPE_FILTER = 'SET_STYLE_PACK_TYPE_FILTER';
export function setStylePackTypeFilter(filterType: string | undefined) {
	return {
		type: SET_STYLE_PACK_TYPE_FILTER,
		payload: filterType,
	};
}

export const SET_STYLE_PACK_CHANNEL_FILTER = 'SET_STYLE_PACK_CHANNEL_FILTER';
export function setStylePackChannelFilter(filter: string) {
	return {
		type: SET_STYLE_PACK_CHANNEL_FILTER,
		payload: filter,
	};
}

export const SHOW_DEPRECATION_WARNING = 'SHOW_DEPRECATION_WARNING';
export function setShowDeprecationWarning(payload: boolean) {
	return {
		type: SHOW_DEPRECATION_WARNING,
		payload,
	};
}

export const SET_RECORDING_BANNER_OPEN = 'SET_RECORDING_BANNER_OPEN';
export function setRecordingBannerOpen(payload: boolean) {
	return {
		type: SET_RECORDING_BANNER_OPEN,
		payload,
	};
}

export const SET_DISPLAYED_STYLE_PACK_INFO = 'SET_DISPLAYED_STYLE_PACK_INFO';
export function setDisplayedStylePackInfo(payload: StylePackData | null) {
	return {
		type: SET_DISPLAYED_STYLE_PACK_INFO,
		payload,
	};
}

export const SCROLL_TO_STYLE_PACK_ID = 'SCROLL_TO_STYLE_PACK_ID';
export function scrollToStylePackId(payload: string) {
	return {
		type: SCROLL_TO_STYLE_PACK_ID,
		payload,
	};
}

export const SET_SOLUTION_CENTER_DRAWER_STATE = 'SET_SOLUTION_CENTER_DRAWER_STATE';
export function setSolutionCenterDrawerState(
	drawer: SolutionCenterDrawerStates,
): SolutionCenterDrawerStateAction {
	return {
		type: SET_SOLUTION_CENTER_DRAWER_STATE,
		payload: {
			drawer,
		},
	};
}

export const SET_SOLUTION_CENTER_CONTENT_STATE = 'SET_SOLUTION_CENTER_CONTENT_STATE';
export function setSolutionCenterContentState(
	content: SolutionCenterContent | null,
	view?: SolutionCenterViews,
): SolutionCenterContentStateAction {
	return {
		type: SET_SOLUTION_CENTER_CONTENT_STATE,
		payload: {
			content,
			view,
		},
	};
}
